// @flow
import * as React from 'react';
import moment from 'moment';
import { IChildInfo } from '../../OnlineWaiver';
import Validators, { IValidatorPackage } from '../../Validators';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import RadioGroup from '../RadioGroup/RadioGroup';
import TextField from '../TextField/TextField';
import * as classNames from 'classnames';
import { YearPicker, MonthPicker, DayPicker } from 'react-dropdown-date';
import { withLocalize, Translate } from "react-localize-redux";

import './ChildInformation.css';

interface IChildInformationProps {
    childrenInfo: IChildInfo[];
    handleClickBack: () => void;
    handleClickNext: () => void;
    updateChildrenInfo: (value: IChildInfo[]) => void;
}

interface IChildInformationState {
    deferErrors: boolean;
}

/**
 * 
 * via https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
 *  
 */
function isValidDate(d) {
    return (d instanceof Date || d instanceof moment) && !isNaN(d);
  }

class ChildInformation extends React.Component<IChildInformationProps, IChildInformationState> {
    validators: {
        [key: string]: IValidatorPackage[];
        firstName: IValidatorPackage[];
        lastName: IValidatorPackage[];
        preferredName: IValidatorPackage[];
        dateOfBirth: IValidatorPackage[];
        yearOfBirth: IValidatorPackage[];
        monthOfBirth: IValidatorPackage[];
        dayOfBirth: IValidatorPackage[];
        gender: IValidatorPackage[];
    };

    constructor(props: IChildInformationProps) {
        super(props);

        this.state = {
            deferErrors: true
        };

        this.validators = {
            firstName: [{
                validator: Validators.requiredNotEmptyString,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            lastName: [{
                validator: Validators.requiredNotEmptyString,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            preferredName: [{
                validator: Validators.passThrough,
                errorMessage: <Translate id="constants_js.required"/>
            }],
            dateOfBirth: [
                {
                    validator: Validators.date,
                    errorMessage: <Translate id="constants_js.date"/>
                },
                {
                    validator: Validators.childNotBornInFuture,
                    errorMessage: <Translate id="constants_js.childNotBornInFuture"/>
                },
                {
                    validator: Validators.ageLessThan18,
                    errorMessage: <Translate id="constants_js.ageLessThan18"/>
                },
                {
                    validator: Validators.aboveMinimumAge,
                    errorMessage: <Translate id="constants_js.belowMinimumAge"/>
                }
            ],
            yearOfBirth: [],
            monthOfBirth: [],
            dayOfBirth: [],
            gender: [{
                validator: Validators.requiredNotEmptyString,
                errorMessage: <Translate id="constants_js.required"/>
            }]
        };
    }

    validate() {
        const validatorKeys = Object.keys(this.validators);
        for (let i = 0; i < validatorKeys.length; i++) {
            const prop = validatorKeys[i];
            const validators = this.validators[prop];
            for (let j = 0; j < validators.length; j++) {
                for (let k = 0; k < this.props.childrenInfo.length; k++) {
                    const validatorPackage = validators[j];
                    //console.log(validatorPackage);
                    if (validatorPackage.validator(this.props.childrenInfo[k][prop]) === false) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    onChildFirstNameChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                newInfo[index].firstName = e.currentTarget.value;
            }
        });
        this.props.updateChildrenInfo(newInfo);
    }

    onChildLastNameChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                newInfo[index].lastName = e.currentTarget.value;
            }
        });
        this.props.updateChildrenInfo(newInfo);
    }

    onChildPreferredNameChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                newInfo[index].preferredName = e.currentTarget.value;
            }
        });
        this.props.updateChildrenInfo(newInfo);
    }

    makeChildBirthDate = (year, month, date) => {
        const dateOfBirth = new moment([year, month, date]);
        return dateOfBirth;
    }

    onChildBirthYearChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                // newInfo[index].yearOfBirth = e;
                // newInfo[index].dateOfBirth = this.makeChildBirthDate(newInfo[index]);
                if (newInfo[index].dateOfBirth === undefined) {
                    newInfo[index].dateOfBirth = moment();
                    newInfo[index].dayOfBirth = false;
                    newInfo[index].monthOfBirth = false;
                    newInfo[index].yearOfBirth = false;
                }
                // const thisYear = moment().year();

                if (isNaN(e)) {
                    newInfo[index].yearOfBirth = false;
                } else {
                    newInfo[index].yearOfBirth = true;
                    newInfo[index].dateOfBirth.year(e);
                }

            }
        });
        this.checkChildOverEight(newInfo);
        this.props.updateChildrenInfo(newInfo);
    }

    onChildBirthMonthChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                if (newInfo[index].dateOfBirth === undefined) {
                    newInfo[index].dateOfBirth = moment();
                    newInfo[index].dayOfBirth = false;
                    newInfo[index].monthOfBirth = false;
                    newInfo[index].yearOfBirth = false;
                }

                if (isNaN(e)) {
                    newInfo[index].monthOfBirth = false;
                } else {
                    newInfo[index].monthOfBirth = true;
                    newInfo[index].dateOfBirth.month(e);
                }
            }
        });
        this.checkChildOverEight(newInfo);
        this.props.updateChildrenInfo(newInfo);
    }

    onChildBirthDayChange = (childIndex: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                if (newInfo[index].dateOfBirth === undefined) {
                    newInfo[index].dateOfBirth = moment();
                    newInfo[index].dayOfBirth = false;
                    newInfo[index].monthOfBirth = false;
                    newInfo[index].yearOfBirth = false;
                }

                if (isNaN(e)) {
                    newInfo[index].dayOfBirth = false;
                } else {
                    newInfo[index].dayOfBirth = true;
                    newInfo[index].dateOfBirth.date(e);
                }
            }
        });
        this.checkChildOverEight(newInfo);
        this.props.updateChildrenInfo(newInfo);
    }

    onChildGenderChange = (childIndex: number, value: string) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
            if (childIndex === index) {
                newInfo[index].gender = value;
            }
        });
        this.props.updateChildrenInfo(newInfo);
    }

    checkChildOverEight = (child) =>{
        const now = moment();

        const diff = now.diff(child.dateOfBirth, 'days')
        const numDays = 365 * 8;
        if(diff <= numDays){
            return true;
        } 
        return false;
    }

    onClickBack = () => {
        this.props.handleClickBack();
    }

    onClickNext = () => {
        if (this.validate()) {
            this.props.handleClickNext();
        }
        else {
            this.setState({ deferErrors: false });
        }
    }

    onClickAddChild = () => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            newInfo.push(Object.assign({}, info));
        });
        newInfo.push({
            firstName: '',
            lastName: '',
            preferredName: '',
            dateOfBirth: new moment(),
            yearOfBirth: false,
            monthOfBirth: false,
            dayOfBirth: false,
            gender: ''
        });
        this.props.updateChildrenInfo(newInfo);
    }

    onClickRemoveChild = (childIndex: number) => {
        const newInfo: IChildInfo[] = [];
        this.props.childrenInfo.forEach((info, index) => {
            if (index !== childIndex) {
                newInfo.push(Object.assign({}, info));
            }
        });
        this.props.updateChildrenInfo(newInfo);
    }

    isBirthdayFinished(childInfo) {
        //console.log("dateOfBirth: ", childInfo);
        return (childInfo !== undefined && childInfo.yearOfBirth && childInfo.monthOfBirth && childInfo.dayOfBirth) ? isValidDate(childInfo.dateOfBirth) : false;
    }

    isBirthdayTooOld(childInfo) {
        return !Validators.ageLessThan18(childInfo.dateOfBirth !== undefined && childInfo.dateOfBirth.toString() ? childInfo.dateOfBirth : false);
    }

    render() {
        return (
            <div className={'ChildInformation'}>
                <Header
                    header={<Translate id="child_information_js.header"/>}
                    subHeader={<Translate id="child_information_js.sub_header"/>}
                />
                {this.props.childrenInfo.map((childInfo, index) => {
                    const birthdayFinished = this.isBirthdayFinished(childInfo);
                    const birthdayTooOld = this.isBirthdayTooOld(childInfo);
                    const birthdayInFuture = !Validators.childNotBornInFuture((childInfo) ? childInfo.dateOfBirth : '');
                    const belowMinimumAge = !Validators.aboveMinimumAge((childInfo) ? childInfo.dateOfBirth : '');
                    const underEight = this.checkChildOverEight(childInfo);
                    // const showError = !birthdayFinished || birthdayTooOld || birthdayInFuture;
                    const birthdayClasses = classNames('BirthdayFields', this.props.className || '', 
                    (!birthdayFinished && !this.state.deferErrors) ? {
                        'BirthdayFields--error-unfinished': !birthdayFinished
                    } : (birthdayInFuture) ? {
                        'BirthdayFields--error-infuture': birthdayInFuture
                    } : (birthdayTooOld) ? {
                        'BirthdayFields--error-over18': birthdayTooOld
                    } : (belowMinimumAge && childInfo.yearOfBirth) ? {
                        'BirthdayFields--error-belowMinimumAge': belowMinimumAge
                    } : (underEight && birthdayFinished) ? {
                        'BirthdayFields--warning-underEight' : underEight
                    } :
                    ''
                    );
                    return (
                        <div key={index} className={'ChildInformation-child'}>
                            <TextField
                                label={<Translate id="child_information_js.label_first_name"/>}
                                value={childInfo.firstName}
                                handleOnChange={this.onChildFirstNameChange.bind(this, index)}
                                required={true}
                                validators={this.validators.firstName}
                                deferErrors={this.state.deferErrors}
                                partialAllowedRegex={/^[a-z ,.'-]+$/i}
                            />
                            <TextField
                                label={<Translate id="child_information_js.label_last_name"/>}
                                value={childInfo.lastName}
                                handleOnChange={this.onChildLastNameChange.bind(this, index)}
                                required={true}
                                validators={this.validators.lastName}
                                deferErrors={this.state.deferErrors}
                                partialAllowedRegex={/^[a-z ,.'-]+$/i}
                            />
                            <TextField
                                label={<Translate id="child_information_js.label_preferred_name"/>}
                                value={childInfo.preferredName}
                                handleOnChange={this.onChildPreferredNameChange.bind(this, index)}
                                required={false}
                                validators={this.validators.preferredName}
                                deferErrors={this.state.deferErrors}
                                partialAllowedRegex={/^[a-z ,.'-]+$/i}
                            />
                            <div className={birthdayClasses}>
                                <div className={'TextField-label'}>
                                    {<Translate id="child_information_js.birthday.title"/>}
                                    {<span className={'TextField-required'}>{' *'}</span>}
                                    {
                                        (birthdayFinished && birthdayTooOld && (
                                            <div className={'TextField-error'}>{<Translate id="child_information_js.birthday.too_old_error"/>}</div>
                                        ))
                                    }
                                    {
                                        (birthdayFinished && birthdayInFuture && (
                                            <div className={'TextField-error'}>{<Translate id="child_information_js.birthday.too_young_error"/>}</div>
                                        ))
                                    }
                                    {
                                        // Use this format going forward, much cleaner and quicker
                                        (birthdayClasses.includes('BirthdayFields--error-unfinished') && (
                                            <div className={'TextField-error'}>{<Translate id="constants_js.belowMinimumAge"/>}</div>
                                        ))
                                    }
                                </div>
                                <Translate>
                                { ({translate}) =>
                                <YearPicker
                                    defaultValue={translate("child_information_js.birthday.year")}
                                    reverse
                                    required={true}
                                    value={(childInfo.yearOfBirth) ? childInfo.dateOfBirth.year() : 'Select Year'}
                                    onChange={this.onChildBirthYearChange.bind(this, index)}
                                    id={'yearOfBirth'}
                                    name={'yearOfBirth-dropdown'}
                                    classes={
                                        classNames('date-dropdown yearOfBirth-dropdown ',
                                        (
                                            (
                                                childInfo.dateOfBirth === undefined 
                                                || moment().diff(childInfo.dateOfBirth, 'years', true) >= 18
                                                || childInfo.yearOfBirth === false
                                            ) ? 'birthdayValueMissing' : '') 
                                        )
                                    }
                                    optionClasses={'option classes'}
                                />
                                }
                                </Translate>
                                <Translate>
                                { ({translate}) =>
                                <MonthPicker
                                    defaultValue={translate("child_information_js.birthday.month")}
                                    endYearGiven
                                    year={childInfo.dateOfBirth.year()}
                                    required={true}
                                    disabled={
                                        (
                                            childInfo.dateOfBirth === undefined 
                                            // || moment().diff(childInfo.dateOfBirth, 'years', true) >= 18
                                            || childInfo.yearOfBirth === false
                                        )
                                    }
                                    value={(childInfo.monthOfBirth) ? childInfo.dateOfBirth.month() : 'Select Month'}
                                    onChange={this.onChildBirthMonthChange.bind(this, index)}
                                    id={'monthOfBirth'}
                                    name={'monthOfBirth'}
                                    classes={
                                        classNames('date-dropdown monthOfBirth-dropdown',
                                        (
                                            (
                                                (
                                                    childInfo.dateOfBirth !== undefined 
                                                    && moment().diff(childInfo.dateOfBirth, 'years', true) < 18
                                                    && childInfo.yearOfBirth === true
                                                ) && (
                                                    childInfo.monthofBirth === false
                                                ) 
                                            ) ? 'birthdayValueMissing' : '') 
                                        )
                                    }
                                    optionClasses={'option classes'}
                                />
                                }
                                </Translate>
                                <Translate>
                                { ({translate}) =>
                                <DayPicker
                                    defaultValue={translate("child_information_js.birthday.day")}
                                    year={childInfo.dateOfBirth.year()}
                                    month={childInfo.dateOfBirth.month()}
                                    endYearGiven
                                    required={true}
                                    disabled={
                                        (
                                            childInfo.dateOfBirth === undefined 
                                            // || moment().diff(childInfo.dateOfBirth, 'years', true) >= 18
                                            || childInfo.yearOfBirth === false
                                            || childInfo.monthOfBirth === false
                                        )
                                    }
                                    value={(childInfo.dayOfBirth) ? childInfo.dateOfBirth.date() : 'Select Day'}
                                    onChange={this.onChildBirthDayChange.bind(this, index)}
                                    id={'dayOfBirth'}
                                    name={'dayOfBirth'}
                                    classes={
                                        classNames('date-dropdown dayOfBirth-dropdown',
                                        (
                                            (
                                                (
                                                    childInfo.dateOfBirth !== undefined 
                                                    && moment().diff(childInfo.dateOfBirth, 'years', true) < 18
                                                    && childInfo.yearOfBirth === true
                                                    && childInfo.monthofBirth === true
                                                ) && (
                                                    childInfo.dayOfBirth === false
                                                ) 
                                            ) ? 'birthdayValueMissing' : '') 
                                        )
                                    }
                                    optionClasses={'option classes'}
                                />
                                }
                                </Translate>
                                {underEight && birthdayFinished && !belowMinimumAge && !birthdayInFuture? 
                                <div className="warning-fix-padding">
                                    <Translate id="child_information_js.birthday.under_eight_notice"/> 
                                </div>
                                : null}
                            </div>
                            <RadioGroup
                                label={<Translate id="child_information_js.label_gender"/>}
                                selectedValue={childInfo.gender}
                                handleChange={this.onChildGenderChange.bind(this, index)}
                                optionLabels={[<Translate id="child_information_js.gender_option_labels.male"/>, <Translate id="child_information_js.gender_option_labels.female"/>, <Translate id="child_information_js.gender_option_labels.other"/>]}
                                optionValues={['Male', 'Female', 'Other']}
                                required={true}
                                validators={this.validators.gender}
                                deferErrors={this.state.deferErrors}
                            />
                            {this.props.childrenInfo.length > 1 && (
                                <div className={'ChildInformation-removeChild'} onClick={this.onClickRemoveChild.bind(this, index)}>
                                    {<Translate id="child_information_js.remove_child"/>}
                                </div>
                            )}
                        </div>
                    );
                })}
                <div className={'ChildInformation-addChild'} onClick={this.onClickAddChild}>
                    {<Translate id="child_information_js.add_child"/>}
                </div>
                <Footer
                    nextEnabled={this.state.deferErrors === true || this.validate()}
                    handleClickBack={this.onClickBack}
                    handleClickNext={this.onClickNext}
                    nextText={<Translate id="footer_js.next"/>}
                    backText={<Translate id="footer_js.back"/>}
                />
            </div>
        );
    }
}

export default withLocalize(ChildInformation);
// export default ChildInformation;
